import React from 'react';
import { useNavigate } from 'react-router-dom';

const ActionBar = ({
  blogDrafts = 0,
  emailsDraft = 0,
  unreviewedCarousel = 0,
  widgetsPending = 0,
  dailyActions = {},
  onDailyActionToggle,
}) => {
  const navigate = useNavigate();

  const countItems = [
    { label: 'Blogs to publish', count: blogDrafts, route: '/admin/content' },
    { label: 'Content to review', count: unreviewedCarousel, route: '/admin/instagram' },
    { label: 'Emails to send', count: emailsDraft, route: '/admin/outreach' },
    { label: 'Submissions pending', count: widgetsPending, route: '/admin/submissions' },
  ];

  const checkoffItems = [
    { label: 'Post-Bridge drafts', field: 'postBridgeReviewed', href: 'https://www.post-bridge.com/dashboard/posts/draft' },
    { label: 'Puzzle video', field: 'puzzleVideoChecked' },
    { label: 'Record video', field: 'videoRecorded' },
  ];

  const visibleCountItems = countItems.filter(i => i.count > 0);
  const allChecksDone = checkoffItems.every(i => dailyActions[i.field]);
  const allClear = visibleCountItems.length === 0 && allChecksDone;

  if (allClear) {
    return (
      <div className="flex gap-2 flex-wrap">
        <span className="px-3 py-1.5 rounded-lg text-xs font-medium bg-green-600/20 text-green-400 border border-green-600/30">
          All clear
        </span>
      </div>
    );
  }

  return (
    <div className="flex gap-2 flex-wrap items-center">
      {visibleCountItems.map((item) => (
        <button
          key={item.label}
          onClick={() => navigate(item.route)}
          className="px-3 py-1.5 rounded-lg text-xs font-medium border transition-opacity hover:opacity-80 bg-orange-600/20 text-orange-400 border-orange-600/30"
        >
          {item.count} {item.label}
        </button>
      ))}

      {checkoffItems.map((item) => {
        const checked = !!dailyActions[item.field];
        const content = (
          <label
            key={item.field}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border cursor-pointer transition-opacity hover:opacity-80 ${
              checked
                ? 'bg-gray-600/20 text-gray-500 border-gray-600/30 line-through'
                : 'bg-blue-600/20 text-blue-400 border-blue-600/30'
            }`}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onDailyActionToggle?.(item.field, !checked)}
              className="w-3 h-3 rounded border-gray-600 bg-gray-700 accent-blue-500"
            />
            {item.label}
            {item.href && !checked && (
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="text-blue-300 hover:text-blue-200 ml-0.5"
              >
                ↗
              </a>
            )}
          </label>
        );
        return content;
      })}
    </div>
  );
};

export default ActionBar;
